export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  videoCount: number;
}

export interface VideoArticle {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export interface FeaturedVideo {
  id: string;
  title: string;
  category: string;
  coverImage: string;
  duration: string;
  views: string;
  rating: string;
}

export interface FAQ {
  question: string;
  answer: string;
}

export const categories: VideoCategory[] = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', description: '最新热门电影，高清画质畅享观影', videoCount: 12580 },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', description: '热门电视剧全集，追剧不等待', videoCount: 8960 },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺节目，欢乐不停歇', videoCount: 5430 },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '海量动漫番剧，二次元世界', videoCount: 9780 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '精彩纪录片，探索世界奥秘', videoCount: 3250 },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line', description: '体育赛事直播与回放', videoCount: 4120 },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-2-line', description: 'MV、演唱会，音乐爱好者天堂', videoCount: 2870 },
  { slug: 'jiaoyu', name: '教育', icon: 'ri-book-open-line', description: '在线学习，知识充电站', videoCount: 1640 },
];

export const featuredVideos: FeaturedVideo[] = [
  { id: 'v1', title: '流浪地球3：星际远征', category: '电影', coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20astronauts%20and%20distant%20planets%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20epic%20space%20atmosphere%2C%20warm%20orange%20and%20deep%20space%20black%20contrast%2C%20movie%20poster%20style%20with%20Chinese%20text%20placeholder%2C%20high%20quality%20film%20grain&width=800&height=450&seq=mango-featured-01&orientation=landscape', duration: '128分钟', views: '1280万', rating: '9.2' },
  { id: 'v2', title: '长安三万里·盛世篇章', category: '动漫', coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20animated%20film%20scene%20with%20golden%20palace%20and%20flowing%20robes%2C%20warm%20sunset%20lighting%2C%20traditional%20Chinese%20painting%20aesthetic%2C%20soft%20watercolor%20texture%2C%20elegant%20historical%20atmosphere&width=800&height=450&seq=mango-featured-02&orientation=landscape', duration: '168分钟', views: '980万', rating: '9.5' },
  { id: 'v3', title: '乘风破浪的姐姐·第五季', category: '综艺', coverImage: 'https://readdy.ai/api/search-image?query=Music%20variety%20show%20stage%20performance%20with%20colorful%20stage%20lights%20and%20dancing%20silhouettes%2C%20concert%20atmosphere%2C%20energetic%20vibe%2C%20warm%20golden%20spotlight%2C%20professional%20stage%20photography&width=800&height=450&seq=mango-featured-03&orientation=landscape', duration: '90分钟/期', views: '2560万', rating: '8.9' },
  { id: 'v4', title: '舌尖上的中国·第四季', category: '纪录片', coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20traditional%20cooking%20scene%2C%20close-up%20food%20photography%20with%20shallow%20depth%20of%20field%2C%20rich%20colors&width=800&height=450&seq=mango-featured-04&orientation=landscape', duration: '50分钟/集', views: '1890万', rating: '9.7' },
  { id: 'v5', title: 'NBA季后赛·巅峰对决', category: '体育', coverImage: 'https://readdy.ai/api/search-image?query=Basketball%20game%20intense%20moment%20with%20player%20dunking%20under%20bright%20arena%20lights%2C%20dynamic%20sports%20photography%2C%20arena%20crowd%20atmosphere%2C%20dramatic%20action%20shot%2C%20warm%20court%20lighting&width=800&height=450&seq=mango-featured-05&orientation=landscape', duration: '120分钟', views: '3200万', rating: '9.3' },
  { id: 'v6', title: '周杰伦·世界巡回演唱会', category: '音乐', coverImage: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20massive%20LED%20screen%20and%20lighting%20effects%2C%20crowd%20waving%20light%20sticks%2C%20music%20concert%20atmosphere%2C%20warm%20golden%20and%20pink%20mood%20lighting%2C%20spectacular%20stage%20design&width=800&height=450&seq=mango-featured-06&orientation=landscape', duration: '150分钟', views: '4580万', rating: '9.8' },
];

export const latestArticles: VideoArticle[] = [
  {
    slug: 'mangoshipin-vs-mitao-tangdou',
    title: '芒果视频 vs 蜜桃视频 vs 糖豆视频：三大平台深度对比评测',
    excerpt: '在众多视频平台中，芒果视频、蜜桃视频和糖豆视频各具特色。本文从资源丰富度、播放流畅度、会员价格、用户体验等多个维度进行全面对比，帮你找到最适合的视频平台。',
    content: '',
    category: '平台对比',
    coverImage: 'https://readdy.ai/api/search-image?query=Three%20video%20streaming%20platform%20logos%20side%20by%20side%20comparison%20concept%2C%20modern%20flat%20design%20style%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20clean%20minimalist%20background%2C%20digital%20entertainment%20theme&width=800&height=420&seq=mango-article-01&orientation=landscape',
    author: '视频达人小王',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    tags: ['平台对比', '芒果视频', '蜜桃视频', '糖豆视频'],
  },
  {
    slug: 'mangoshipin-app-tiyan',
    title: '芒果视频App深度体验：免费高清真的靠谱吗？',
    excerpt: '芒果视频App主打免费高清观影体验，那么它到底好不好用？本文从界面设计、视频加载速度、画质表现、广告情况等方面详细评测，告诉你真实的使用感受。',
    content: '',
    category: '使用评测',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%2C%20modern%20mobile%20UI%20design%2C%20warm%20lighting%20on%20phone%20screen%2C%20clean%20background%2C%20app%20review%20concept&width=800&height=420&seq=mango-article-02&orientation=landscape',
    author: '数码评测师阿杰',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    tags: ['使用评测', '芒果视频App', '免费高清'],
  },
  {
    slug: 'top-10-shipin-pingtai-tuijian',
    title: '2026年十大免费视频平台推荐，芒果视频位列前三',
    excerpt: '整理了2026年最受欢迎的十个免费视频平台，包括芒果视频、蘑菇视频、蓝莓视频等。从资源数量、更新速度、画质清晰度等角度分析各平台优劣，助你选对平台。',
    content: '',
    category: '平台推荐',
    coverImage: 'https://readdy.ai/api/search-image?query=Top%2010%20ranking%20list%20concept%20with%20streaming%20platform%20icons%2C%20modern%20infographic%20style%2C%20warm%20gradient%20background%2C%20digital%20media%20theme%2C%20clean%20professional%20design&width=800&height=420&seq=mango-article-03&orientation=landscape',
    author: '追剧小助手',
    publishDate: '2026-07-20',
    readTime: '10分钟',
    tags: ['平台推荐', '十大视频平台', '芒果视频', '蘑菇视频', '蓝莓视频'],
  },
  {
    slug: 'mianfei-gaoqing-zhuiju-zhinan',
    title: '免费高清追剧指南：芒果视频资源全攻略',
    excerpt: '芒果视频拥有海量影视资源，涵盖电影、电视剧、综艺、动漫等多种类型。本文将详细介绍如何高效利用芒果视频找到你想看的内容，以及一些实用小技巧。',
    content: '',
    category: '使用指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Binge%20watching%20concept%20with%20laptop%20and%20popcorn%20on%20cozy%20sofa%2C%20warm%20living%20room%20atmosphere%2C%20soft%20indoor%20lighting%2C%20comfortable%20home%20entertainment%20scene%2C%20lifestyle%20photography&width=800&height=420&seq=mango-article-04&orientation=landscape',
    author: '追剧小助手',
    publishDate: '2026-07-18',
    readTime: '7分钟',
    tags: ['使用指南', '追剧攻略', '芒果视频资源'],
  },
  {
    slug: 'mangoshipin-mogu-lanmei-duibi',
    title: '芒果视频、蘑菇视频、蓝莓视频横向对比：谁更好用？',
    excerpt: '芒果视频、蘑菇视频、蓝莓视频三个平台名字相似但各有千秋。我们从视频资源、播放体验、界面设计、会员服务等多角度进行详细横向对比。',
    content: '',
    category: '平台对比',
    coverImage: 'https://readdy.ai/api/search-image?query=Three%20competing%20video%20apps%20interface%20comparison%20on%20three%20smartphones%20side%20by%20side%2C%20product%20comparison%20concept%2C%20warm%20minimalist%20background%2C%20tech%20review%20photography&width=800&height=420&seq=mango-article-05&orientation=landscape',
    author: '视频达人小王',
    publishDate: '2026-07-15',
    readTime: '9分钟',
    tags: ['平台对比', '芒果视频', '蘑菇视频', '蓝莓视频'],
  },
  {
    slug: 'mangoshipin-xiazaianzhuang',
    title: '芒果视频App下载安装教程：一分钟搞定',
    excerpt: '想用芒果视频但不知道如何下载？本文提供详细的芒果视频App下载和安装步骤，支持安卓和iOS双平台，附带常见问题解答，让你轻松开始观影之旅。',
    content: '',
    category: '使用指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20app%20download%20concept%20with%20app%20store%20icon%20on%20phone%20screen%2C%20modern%20mobile%20photography%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%2C%20tech%20tutorial%20style&width=800&height=420&seq=mango-article-06&orientation=landscape',
    author: '数码评测师阿杰',
    publishDate: '2026-07-12',
    readTime: '5分钟',
    tags: ['使用指南', '下载安装', '芒果视频App'],
  },
];

export const faqs: FAQ[] = [
  {
    question: '芒果视频好用吗？和其他平台相比有什么优势？',
    answer: '芒果视频作为新兴视频平台，资源丰富且更新速度快。相比蜜桃视频、糖豆视频等同类平台，芒果视频在播放流畅度、画质清晰度和界面友好度方面都有明显优势。平台支持1080P高清和4K超清画质，免费用户即可享受高清观影体验。与蘑菇视频、蓝莓视频等竞品对比，芒果视频的广告时间更短，加载速度更快，整体用户体验更为出色。',
  },
  {
    question: '芒果视频的资源丰富吗？有没有最新电影和电视剧？',
    answer: '芒果视频拥有超过5万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片、体育、音乐、教育等八大类别。平台与多家内容提供商合作，确保热门电影和电视剧及时更新。无论是国产新片还是海外大片，都能在芒果视频找到。平台还设有独家内容专区，为用户提供更多优质选择。',
  },
  {
    question: '芒果视频App是免费的吗？需要会员吗？',
    answer: '芒果视频App提供免费和会员两种观看模式。免费用户即可观看绝大部分内容，支持高清画质。会员用户可享受4K超清画质、免广告、离线下载、多设备同时登录等增值服务。平台定期推出会员优惠活动，性价比很高。总体而言，即使是免费体验，芒果视频也能满足大多数用户的观影需求。',
  },
  {
    question: '芒果视频支持哪些设备？可以在电视上看吗？',
    answer: '芒果视频支持多平台多设备使用，包括手机（iOS和安卓）、平板电脑、电脑网页端以及智能电视。你可以通过芒果视频App在手机上随时随地观看，也可以通过投屏功能将内容投射到电视大屏上享受家庭影院体验。智能电视用户还可以直接安装TV版应用，操作简便。',
  },
  {
    question: '芒果视频的播放流畅度怎么样？会不会卡顿？',
    answer: '芒果视频采用了先进的CDN加速技术和智能码率调节算法，能够根据用户的网络状况自动调整画质，确保播放流畅不卡顿。在全国主要城市部署了服务器节点，即使在网络高峰期也能保持稳定流畅的播放体验。根据用户反馈，芒果视频的播放流畅度在同类型平台中名列前茅，卡顿率远低于行业平均水平。',
  },
  {
    question: '芒果视频和蜜桃视频、糖豆视频有什么不同？',
    answer: '芒果视频与蜜桃视频、糖豆视频虽然都是视频平台，但定位各有侧重。芒果视频主打综合视频资源和极致播放体验，资源覆盖面更广；蜜桃视频侧重于特定类型内容，糖豆视频则以短视频为主。相比之下，芒果视频在长视频资源、播放质量和用户界面上投入更多，更适合追求高品质观影体验的用户。',
  },
];